import AppBar from "@material-ui/core/AppBar"
import Button from "@material-ui/core/Button"
import { makeStyles } from "@material-ui/core/styles"
import Toolbar from "@material-ui/core/Toolbar"
import Typography from "@material-ui/core/Typography"
import { useHistory } from "react-router-dom"

import {
    Badge,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    Drawer,
    List,
    ListItem,
    ListItemText,
    ListSubheader,
    Popover,
    Switch,
    Tooltip,
    useMediaQuery,
    useTheme,
} from "@material-ui/core"
import IconButton from "@material-ui/core/IconButton"
import {
    AccessAlarm,
    AccountCircle,
    AddBox,
    ArrowDropDown,
    Chat,
    ChevronLeft,
    ChevronRight,
    Close,
    Dashboard,
    Deck,
    Edit,
    GetApp,
    InfoOutlined,
    LocationSearching,
    Menu,
    MenuBook,
    MonetizationOn,
    PostAdd,
    Print,
    ReportProblemOutlined,
    RoomService,
    Send,
    Settings,
    SettingsApplications,
    TrendingUp,
    VolumeUp,
    WhatsApp,
} from "@material-ui/icons"
import ExitToAppIcon from "@material-ui/icons/ExitToApp"
import clsx from "clsx"
import { useCallback, useContext, useEffect, useRef, useState } from "react"

import { useParams } from "react-router-dom/cjs/react-router-dom.min"
import useParametros from "../../contexts/ParametrosContext"
import ServicosContext from "../../contexts/servicosContext"
import { pegarFaturasEmAberto } from "../../services/comum"
import { AlertasPainel } from "../../services/fornecedor"
import { getIdEstabelecimentoAtual } from "../../services/quitacaoAutomatica"
import useAppStore from "../../stores/AppStore"
import { forcarImpressaoNavegador } from "../../stores/ImpressaoStore"
import { assinarImpressoraLider } from "../../stores/impressaoLider"
import { useOperacaoTempoReal, silenciarAvisoTodasAbas } from "../../components/OperacaoTempoReal"
import { clearWhatsappOfficialSession } from "../../utils/whatsappOfficialSession"
import DialogTrocaEstabelecimento from "../DialogTrocaEstabelecimento"
import ConfiguracaoImpressao from "../RecebedorDePedidos/components/ConfiguracaoImpressao"
import DialogAlertas from "../RecebedorDePedidos/DialogAlertas"
import BarraPerfil from "./BarraPerfil"
import BotaoStatusLoja from "./StatusLoja"

// Módulo de impressão (Cliente Fiel Printer). Necessário para a impressão
// automática sair sem ação do usuário quando o painel está em modo automático.
const URL_MODULO_IMPRESSAO =
    "https://clientefielsp.s3-sa-east-1.amazonaws.com/Cliente+Fiel+Printer.zip"
const URL_INSTRUCOES_IMPRESSAO =
    "https://ajuda.clientefiel.app/painel-cliente-fiel/ferramentas/formas-de-impressao"

const drawerWidth = 250
const miniDrawerWidth = 80

// Faixa de alerta padrão exibida no topo da página (abaixo do cabeçalho). Usada
// tanto para o módulo de impressão quanto para os avisos de fatura, para manter o
// mesmo estilo. `aoFechar` (opcional) mostra um botão de dispensar à direita.
function FaixaAlerta({ cor, icone, onClick, aoFechar, children }) {
    return (
        <div
            onClick={onClick}
            style={{
                backgroundColor: cor,
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
                padding: "6px 16px",
                cursor: onClick ? "pointer" : "default",
                fontWeight: 600,
                fontSize: "0.85rem",
                lineHeight: 1.3,
                textAlign: "center",
                boxShadow: "inset 0 1px 0 rgba(0,0,0,0.12)",
            }}
        >
            {icone}
            <span>{children}</span>
            {aoFechar && (
                <IconButton
                    size="small"
                    onClick={e => {
                        e.stopPropagation()
                        aoFechar()
                    }}
                    style={{ color: "white", padding: 2 }}
                >
                    <Close fontSize="small" />
                </IconButton>
            )}
        </div>
    )
}

const useStyles = makeStyles((theme, openBarraLateral) => ({
    root: {
        display: "flex",
    },
    appBar: {
        width: `calc(100% - ${miniDrawerWidth}px)`,
        marginLeft: miniDrawerWidth,
        transition: theme.transitions.create(["margin", "width"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        [theme.breakpoints.down("md")]: {
            width: "100%",
            marginLeft: 0,
        },
    },
    painelInstaladoStyle: {},
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(["margin", "width"], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        [theme.breakpoints.down("md")]: {
            width: "100%",
            marginLeft: 0,
        },
    },
    menuButton: {
        marginRight: theme.spacing(2),
        [theme.breakpoints.up("lg")]: {
            display: "none",
        },
    },
    drawer: {
        position: "fixed",
        zIndex: 3,
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: "nowrap",
        [theme.breakpoints.down("md")]: {
            display: "none",
        },
    },
    mobileDrawer: {
        [theme.breakpoints.up("lg")]: {
            display: "none",
        },
    },
    drawerOpen: {
        zIndex: 10,
        width: drawerWidth,
        background: "linear-gradient(180deg, #3e3e3e 0%, #1f1f1f 100%)",
        color: "white",
        borderRight: "none",
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),

        "& .MuiTypography-root": { color: "#bdc3c7" },
        "& .MuiSvgIcon-root": { color: "#bdc3c7" },

        "& .MuiListItem-root": {
            borderRadius: 8,
            margin: "2px 8px",
            paddingLeft: 10,
            "&:hover": {
                backgroundColor: "rgba(255,255,255,0.08)",
                "& .MuiTypography-root, & .MuiSvgIcon-root": { color: "#fff" },
            },
        },
    },
    drawerClose: {
        zIndex: 10,
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: "hidden",
        width: miniDrawerWidth,
        backgroundColor: "#3e3e3e",
        color: "white",
        borderRight: "none",
        [theme.breakpoints.up("sm")]: {
            width: miniDrawerWidth,
        },
        "& .MuiListItem-root": {
            color: "#bdc3c7",
            margin: "2px 8px",
            borderRadius: "8px",
            "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                color: "white",
            },
        },
        "& .MuiSvgIcon-root": {
            color: "#bdc3c7",
        },
        "& .MuiIconButton-root": {
            color: "#bdc3c7",
            "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                color: "white",
            },
        },
    },
    drawerHeader: {
        display: "flex",
        alignItems: "center",
        padding: theme.spacing(0, 1),
        ...theme.mixins.toolbar,
        justifyContent: "space-between",
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create("margin", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: miniDrawerWidth,
        [theme.breakpoints.down("md")]: {
            marginLeft: 0,
        },
    },
    lista: {
        width: "100%",
    },
    scrollbarCustom: {
        "&::-webkit-scrollbar": {
            width: "8px",
        },
        "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
        },
        "&::-webkit-scrollbar-thumb": {
            background: "#888",
            borderRadius: "10px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
            background: "#555",
        },
    },
    botaoAviso: {
        color: "yellow",
        margin: "0 1rem",
        "& > span > span": {
            "& > span": {
                backgroundColor: "white",
                color: "black",
            },
        },
    },
    // Sino de novos pedidos (indicador para testes de SSE).
    botaoNovoPedido: {
        color: "#fff",
        margin: "0 0.5rem",
    },
    "@keyframes balancarBandeja": {
        "0%, 100%": { transform: "rotate(0deg)" },
        "20%": { transform: "rotate(-18deg)" },
        "40%": { transform: "rotate(14deg)" },
        "60%": { transform: "rotate(-10deg)" },
        "80%": { transform: "rotate(6deg)" },
    },
    bandejaBalancando: {
        color: "#ffeb3b",
        transformOrigin: "50% 0",
        animation: "$balancarBandeja 0.7s ease-in-out infinite",
    },
    badgeNovo: {
        fontSize: 8,
        height: 14,
        minWidth: 14,
        padding: "0 4px",
        fontWeight: "bold",
        textTransform: "uppercase",
    },
    botoesMenu: {
        backgroundColor: "#0277BD",
        borderRadius: "10px",
        margin: "0.1em",
        color: "#fafafa",
        "&:hover": {
            backgroundColor: "#01579B",
        },
    },
    drawerHeaderMini: {
        display: "flex",
        alignItems: "center",
        padding: "4px",
        paddingInline: "0.8rem",
        justifyContent: "end",
    },
    sectionLabel: {
        color: "#9aa0a6",
        fontSize: 12,
        letterSpacing: 0.6,
        textTransform: "uppercase",
        padding: "12px 16px 6px",
    },
    billBanner: {
        margin: "8px auto",
        padding: "10px 12px",
        backgroundColor: "#27ae60",
        borderRadius: 8,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        color: "white",
        cursor: "pointer",
        width: "90%",
        "&:hover": {
            backgroundColor: "#219150",
        },
    },
    listItemIcon: { minWidth: 36 },
    listItemText: { "& .MuiTypography-root": { fontSize: 14 } },
}))

const CHAVE_AVISOS_VISTOS = "avisosSistemaVistos"

/** Hash (djb2) do conjunto de avisos — muda se algum aviso entra, sai ou é editado. */
const assinarAlertas = lista => {
    const texto = lista.join(" ")
    let hash = 5381
    for (let i = 0; i < texto.length; i++) {
        hash = ((hash << 5) + hash + texto.charCodeAt(i)) | 0
    }
    return String(hash)
}

export default function Cabecalho(props) {
    const history = useHistory()
    const theme = useTheme()
    const mobile = useMediaQuery(theme.breakpoints.down("md"))
    // Telas estreitas (celular): compacta rótulos do cabeçalho para caber tudo.
    const telaEstreita = useMediaQuery(theme.breakpoints.down("sm"))
    const configs = useAppStore(s => s.configuracoes)
    const parametros = useParametros()

    const { icone, pagina, subtitulo, desconectar, registrarPedidoMesa, trocarEstabelecimento } =
        props

    const {
        handleRegistradorDePedidos,
        handleAceitadorDePedidos,
        handleNotaFiscal,
        handleIzzaBot,
        handleGeradorQrCode,
        handlePedidoDeMesa,
        handleAreaDeEntrega,
        handleIntegracoes,
        handlePDVoz,
        handleSistemaAdm,
        handleCaixa,
        handleCardapio,
        handleGaleria,
        handleCardapioMassa,
        handleCardapioInsumos,
        handleCardapioFichaTecnica,
        handleCardapioHistorico,
        handleParametros,
        handleParametrosDelivery,
        handleParametrosAvancados,
        handlePedidosAgendados,
        handleAgendamentoPeriodos,
        handleAgendamentoConfiguracoes,
        handleAvaliacaoDelivery,
        handleClientes,
        handlePesquisaSatisfacaoFornecedor,
        handleDadosFornecedor,
        handleBairros,
        handleEnderecosBloqueados,
        handleFormasDePagamento,
        handleImportarClientes,
        handlePerguntasPesquisaSatisfacao,
        handlePreferenciasImpressao,
        handleTelefonesBloqueados,
        handleIntegracaoOpenDelivery,
        handleTestarOpenDelivery,
        handleOpenDeliveryIntegradores,
        handleUsuariosPainel,
        handleTurnos,
        handleEntregadores,
        handleNotificacoes,
        handleNotificacaoPush,
        handleIntegracaoWhatsapp,
        handleHome,
        handleConversasWhatsapp,
        handleCriarTemplateWhatsapp,
        handleEnvioTemplateWhatsappGrupo,
        handleQRCodesMesa,
        handleHistoricoVersoes,
        handleBanners,
        handleConfiguracaoFiscal,
        handleCuponsDesconto,
        handleMarketingAutomatico,
        handleParametrosClienteFiel,
        handlePromocaoFidelidade,
        handlePromocoes,
        handleSelosPremiadosFornecedor,
        handleBrindesResgatados,
        handleCartelas,
        handleComparativoUnidades,
        handleEmissaoCupomFiscal,
        handleEmissoesParaMeuCNPJ,
        handleEstrategias,
        handleExtratoDetalhado,
        handleExtratoPagarme,
        handleHistoricoCaixa,
        handleHistoricoFechamentos,
        handleHistoricoMesas,
        handleIndicacoesAmigos,
        handleListarProdutos,
        handleModulosContratados,
        handleAssinatura,
        handlePosicaoClientes,
        handleRelatorioPedidos,
        handleResumo,
        handleCoresAplicativo,
        handleCadastroAplicativo,
        handleParametrosAplicativo,
        handleArquivosAplicativo,
        handleContratoAplicativo,
        handleEstabelecimentosAplicativo,
        handleRespostasPersonalizadasIzza,
        handleModeloIzzaGPT,
        handleEnviosIzza,
    } = useContext(ServicosContext)

    const tabStatus = useAppStore(s => s.tabStatus)
    const setTabStatus = useAppStore(s => s.setTabStatus)
    const atualizarConfiguracoes = useAppStore(s => s.atualizarConfiguracoes)
    // Som bloqueado pelo autoplay do navegador: mostra a faixa para o usuario liberar
    // com um clique (o gesto exigido). Nunca aparece com o som desligado, pois
    // `ativarAviso` sai antes de tentar tocar (nao seta `somBloqueado`).
    const somBloqueado = useAppStore(s => s.somBloqueado)
    const autorizarSom = useAppStore(s => s.autorizarSom)
    const emVisualizacao = tabStatus === "VIEW"
    const emModoGarcom = tabStatus === "GARCOM"

    // Modo unificado = tabStatus (Operação/Visualização/Garçom) + aceite automático do recebedor.
    const aceiteAutomatico =
        configs?.recebedor?.aceiteAutomatico ??
        (configs?.recebedor?.aceitarPedidoAutomatico ? "TELA_ABERTA" : "DESLIGADO")
    // QZ "configurado" = o usuário escolheu impressão via QZ (não forçou o navegador) e
    // selecionou ao menos uma impressora. É a base persistente da configuração, não
    // depende do websocket estar ativo neste instante (o alerta "módulo de impressão não
    // encontrado" cobre o caso de estar configurado, porém com o módulo fechado). Sem o
    // QZ configurado, a operação automática não imprime nada, então não é oferecida.
    const qzConfigurado =
        !forcarImpressaoNavegador() && (configs?.printer?.impressoras?.length ?? 0) > 0
    // O antigo modo "Operação automática (só com o Painel)" (TELA_ABERTA) foi removido:
    // quem estava nele é redirecionado para "Operação automática" (SEMPRE). Aqui ele já
    // conta como automático para não piscar "Manual" antes de a migração persistir.
    const modoAtual = emModoGarcom
        ? "GARCOM"
        : emVisualizacao
        ? "VIEW"
        : aceiteAutomatico === "SEMPRE" || aceiteAutomatico === "TELA_ABERTA"
        ? "AUTO_SEMPRE"
        : "MANUAL"
    const corModo = emModoGarcom ? "#1f6feb" : emVisualizacao ? "#f5a623" : "#2e9e5b"
    const rotuloModo =
        modoAtual === "GARCOM"
            ? "Garçom"
            : modoAtual === "VIEW"
            ? "Visualização"
            : modoAtual === "AUTO_SEMPRE"
            ? "Automática"
            : "Manual"
    // Rótulo curto para telas estreitas (sem o prefixo "Modo:").
    const rotuloModoCurto =
        modoAtual === "GARCOM"
            ? "Garçom"
            : modoAtual === "VIEW"
            ? "Visual."
            : modoAtual === "AUTO_SEMPRE"
            ? "Auto"
            : "Manual"

    // Opções do dropdown de Modo (define tabStatus + aceite automático de uma vez).
    const opcoesModo = [
        {
            id: "AUTO_SEMPRE",
            cor: "#2e9e5b",
            titulo: "Operação automática",
            descricao: qzConfigurado
                ? "Aceita e imprime os pedidos automaticamente, com qualquer tela do sistema aberta."
                : "Aceita os pedidos automaticamente em qualquer tela. Sem o QZ configurado, a comanda sai pela impressão do navegador (botão Imprimir no aviso de pedido pronto).",
        },
        {
            id: "MANUAL",
            cor: "#2e9e5b",
            titulo: "Operação manual",
            descricao: "Você aceita e imprime cada pedido.",
        },
        {
            id: "VIEW",
            cor: "#f5a623",
            titulo: "Visualização",
            descricao:
                "Só acompanha os pedidos. Não aceita nem imprime, mesmo com aceite automático ligado.",
        },
        {
            id: "GARCOM",
            cor: "#1f6feb",
            titulo: "Garçom (só lançamento)",
            descricao:
                "Terminal de lançamento para o celular do garçom: não recebe, não toca, não imprime e não fica online no tempo real. A comanda sai na estação da loja.",
        },
    ]

    const [anchorModo, setAnchorModo] = useState(null)
    const selecionarModo = opcao => {
        // Registra que o operador escolheu um modo manualmente nesta estação: desliga a
        // auto-ativação do modo Garçom (celular sem QZ) para respeitar a escolha nos
        // próximos loads.
        try {
            localStorage.setItem("modoOperacaoManual", "1")
        } catch {
            /* ignore */
        }
        // Operação automática NÃO exige QZ: o aceite é feito pelo backend e, sem QZ, a
        // comanda cai na impressão pelo navegador (aviso "pedido pronto — clique para
        // imprimir"). Antes o modo era bloqueado sem QZ; agora fica disponível para o
        // pedido ser aceito automaticamente mesmo em estações sem impressora térmica.
        // Ordem importa: CRUD antes de atualizarConfiguracoes, pois o aceite do backlog
        // (aceitarPedidosAutomaticos) tem guarda de VIEW e seria ignorado em modo VIEW.
        switch (opcao) {
            case "AUTO_SEMPRE":
                setTabStatus("CRUD")
                atualizarConfiguracoes({ recebedor: { aceiteAutomatico: "SEMPRE" } })
                break
            case "MANUAL":
                setTabStatus("CRUD")
                atualizarConfiguracoes({
                    recebedor: {
                        aceiteAutomatico: "DESLIGADO",
                        prepararPedidoAutomatico: false,
                    },
                })
                break
            case "GARCOM":
                // Terminal de lançamento: sem aceite/impressão automáticos.
                setTabStatus("GARCOM")
                atualizarConfiguracoes({
                    recebedor: {
                        aceiteAutomatico: "DESLIGADO",
                        prepararPedidoAutomatico: false,
                    },
                })
                // O garçom lança pedido: leva direto para o Registrador (a estação em
                // Garçom não recebe/aceita, então o painel de recebimento não faz sentido).
                history.push("/servicos/modulo/registrador-de-pedidos")
                break
            case "VIEW":
            default:
                setTabStatus("VIEW")
                break
        }
        setAnchorModo(null)
    }

    // "Preparar pedidos automaticamente" vive junto do seletor de Operação: só faz sentido
    // com o aceite automático ligado, então o switch fica desabilitado fora do modo
    // automático. Ao entrar em Manual/Visualização o preparo é desligado no próprio fluxo.
    const preparoAutomatico = !!configs?.recebedor?.prepararPedidoAutomatico
    const preparoDisponivel = modoAtual === "AUTO_SEMPRE"
    const alternarPreparo = e =>
        atualizarConfiguracoes({
            recebedor: { prepararPedidoAutomatico: e.target.checked },
        })

    const [openBarraLateral, setOpen] = useState(false)
    const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false)
    const classes = useStyles()

    const handleDrawerOpen = () => {
        if (mobile) {
            setMobileDrawerOpen(true)
        } else {
            setOpen(true)
        }
    }

    const handleDrawerClose = () => {
        if (mobile) {
            setMobileDrawerOpen(false)
        } else {
            setOpen(false)
        }
    }

    const handleMobileDrawerToggle = () => {
        setMobileDrawerOpen(!mobileDrawerOpen)
    }

    const { tela } = useParams()
    const [openDialogAlterarEstabelecimento, setOpenDialogAlterarEstabelecimento] = useState(false)

    // Aviso de assinatura em período de avaliação (assinatura ativo=4 → assinaturaEmAvaliacao).
    const emAvaliacao = !!configs?.user?.parametros?.assinaturaEmAvaliacao
    const [dialogAvaliacao, setDialogAvaliacao] = useState(false)
    const [faturaAvaliacao, setFaturaAvaliacao] = useState(null)

    const abrirAvaliacao = async () => {
        setDialogAvaliacao(true)
        try {
            const idEstab = getIdEstabelecimentoAtual()
            if (!idEstab) return
            const resp = await pegarFaturasEmAberto(idEstab)
            const lista = Array.isArray(resp) ? resp : []
            if (lista.length) setFaturaAvaliacao(lista[0])
        } catch (e) {
            // silencioso — o aviso ainda explica o período de avaliação
        }
    }

    const formatarVencimento = d => {
        if (!d) return ""
        const iso = String(d).slice(0, 10)
        const partes = iso.split("-")
        return partes.length === 3 ? `${partes[2]}/${partes[1]}/${partes[0]}` : iso
    }
    const handleToggleDialogAlterarEstabelecimento = () => {
        setOpenDialogAlterarEstabelecimento(prev => !prev)
    }

    const [anchorAgendamento, setAnchorAgendamento] = useState(null)
    const openAagendamento = Boolean(anchorAgendamento)
    const handleOpenAgendamento = event => setAnchorAgendamento(event.currentTarget)
    const handleCloseAgendamento = () => setAnchorAgendamento(null)

    const [anchorConsultas, setAnchorConsultas] = useState(null)
    const openConsultas = Boolean(anchorConsultas)
    const handleOpenConsultas = event => setAnchorConsultas(event.currentTarget)
    const handleCloseConsultas = () => setAnchorConsultas(null)

    const [anchorLayout, setAnchorLayout] = useState(null)
    const openLayout = Boolean(anchorLayout)
    const handleOpenLayout = event => setAnchorLayout(event.currentTarget)
    const handleCloseLayout = () => setAnchorLayout(null)

    const [anchorWhatsApp, setAnchorWhatsApp] = useState(null)
    const openWhatsApp = Boolean(anchorWhatsApp)
    const handleOpenWhatsApp = event => setAnchorWhatsApp(event.currentTarget)
    const handleCloseWhatsApp = () => setAnchorWhatsApp(null)

    const [anchorElCardapio, setAnchorElCardapio] = useState(null)
    const openCardapio = Boolean(anchorElCardapio)
    const handleOpenCardapio = event => setAnchorElCardapio(event.currentTarget)
    const handleCloseCardapio = () => setAnchorElCardapio(null)

    const [anchorElPedidos, setAnchorElPedidos] = useState(null)
    const openPedidos = Boolean(anchorElPedidos)
    const handleOpenPedidos = e => setAnchorElPedidos(e.currentTarget)
    const handleClosePedidos = () => setAnchorElPedidos(null)

    const [anchorElCadastros, setAnchorElCadastros] = useState(null)
    const openCadastros = Boolean(anchorElCadastros)
    const handleOpenCadastros = e => setAnchorElCadastros(e.currentTarget)
    const handleCloseCadastros = () => setAnchorElCadastros(null)

    const [anchorElFinanceiro, setAnchorElFinanceiro] = useState(null)
    const openFinanceiro = Boolean(anchorElFinanceiro)
    const handleOpenFinanceiro = e => setAnchorElFinanceiro(e.currentTarget)
    const handleCloseFinanceiro = () => setAnchorElFinanceiro(null)

    const perfilUsuario = configs.user.perfil
    const isPerfilWhatsappOperador = perfilUsuario === "WHATSAPP"
    // DELIVERY_BASICO / DELIVERY veem apenas o menu Pedidos, por isso ficam fora dos perfis completos
    const perfilCompleto = ["ADMINISTRADOR", "CLIENTEFIEL"].includes(perfilUsuario)
    const perfilAdm = ["ADMINISTRADOR", "CLIENTEFIEL"].includes(perfilUsuario)
    const perfilClienteFiel = ["CLIENTEFIEL"].includes(perfilUsuario)
    // Perfis que podem acessar o Cardápio: os completos + o perfil dedicado DELIVERY_CARDAPIO
    const perfilCardapio = perfilCompleto || perfilUsuario === "DELIVERY_CARDAPIO"
    // Perfis que podem acessar a tela Pedidos do Dia: completos + todos os de delivery
    const perfilPedidosDia =
        perfilCompleto ||
        ["DELIVERY", "DELIVERY_BASICO", "DELIVERY_CARDAPIO"].includes(perfilUsuario)
    const mostrarSistemaADM = perfilUsuario === "ADMINISTRADOR" || perfilUsuario === "CLIENTEFIEL"

    // ── Avisos do sistema (sino de notificações) ──
    // Disponível em todas as telas: o Cabeçalho busca os avisos e controla o sino/dialog.
    // O "já vi" fica em sessionStorage de propósito: fechar e reabrir o navegador começa
    // uma sessão nova e os avisos voltam a aparecer.
    const [alertasSistema, setAlertasSistema] = useState([])
    const [abrirAlertas, setAbrirAlertas] = useState(false)
    const assinaturaAlertasRef = useRef(null)

    useEffect(() => {
        let ativo = true
        const buscarAlertas = async () => {
            try {
                const resposta = await AlertasPainel()
                if (!ativo || !Array.isArray(resposta)) return

                const lista = resposta.map(alerta =>
                    alerta.replaceAll("\n", "").replaceAll("\r", "")
                )
                setAlertasSistema(lista)

                // O que faz o popup voltar a aparecer é a assinatura mudar: cadastrar,
                // editar ou remover um aviso gera outro hash, então o "já vi" guardado
                // não bate mais e os avisos abrem sozinhos no próximo carregamento.
                const assinatura = assinarAlertas(lista)
                assinaturaAlertasRef.current = assinatura

                if (
                    lista.length > 0 &&
                    sessionStorage.getItem(CHAVE_AVISOS_VISTOS) !== assinatura
                ) {
                    setAbrirAlertas(true)
                }
            } catch (error) {
                console.error(error)
            }
        }
        buscarAlertas()
        return () => {
            ativo = false
        }
    }, [])

    // Só marca como visto quando o usuário fecha — sair da tela sem fechar deixa o aviso
    // para a próxima vez, que é o comportamento pedido.
    const fecharAlertas = valor => {
        setAbrirAlertas(valor)
        if (!valor && assinaturaAlertasRef.current) {
            sessionStorage.setItem(CHAVE_AVISOS_VISTOS, assinaturaAlertasRef.current)
        }
    }

    // ── Indicador de novo pedido (SSE) ──
    // A bandeja balança por 30s ao chegar um novo pedido. Quem assina o stream é o
    // `useOperacaoTempoReal` (SSE + rede de segurança + QZ), que o Cabeçalho monta por
    // estar em quase toda tela — e o Registrador monta por conta própria, já que lá o
    // Cabeçalho normalmente não aparece. O hook do SSE elege um líder por navegador
    // (Web Locks), então continua havendo apenas UMA conexão.
    const [novoPedidoRecente, setNovoPedidoRecente] = useState(false)
    const timerBandejaRef = useRef(null)
    const dispararBandeja = useCallback(() => {
        setNovoPedidoRecente(true)
        if (timerBandejaRef.current) clearTimeout(timerBandejaRef.current)
        timerBandejaRef.current = setTimeout(() => setNovoPedidoRecente(false), 30000)
    }, [])

    useEffect(() => {
        return () => {
            if (timerBandejaRef.current) clearTimeout(timerBandejaRef.current)
        }
    }, [])

    // SSE (aceite/impressão automática + som), rede de segurança do allday, manutenção do
    // QZ, modo padrão de operação, faixa de impressão pendente e desbloqueio do áudio:
    // tudo em `useOperacaoTempoReal`, compartilhado com as telas que não montam o
    // Cabeçalho (Registrador de Pedidos). O `qzAtivo` de lá alimenta os avisos abaixo:
    //  - QZ não encontrado (módulo ausente);
    //  - QZ ativo, porém sem impressora configurada.
    const { qzAtivo } = useOperacaoTempoReal({ onNovoPedido: dispararBandeja })

    const [dialogImpressao, setDialogImpressao] = useState(false)
    const [dialogConfigImpressao, setDialogConfigImpressao] = useState(false)

    // Esta aba é a "impressora" do navegador? Só UMA aba por navegador imprime de
    // fato (eleição por Web Lock em impressaoLider). O título da aba já ganha o 🖨️,
    // mas ele nem sempre fica visível — então mostramos também um selo no cabeçalho.
    const [souImpressora, setSouImpressora] = useState(false)
    useEffect(() => assinarImpressoraLider(setSouImpressora), [])

    const emModoAutomatico = aceiteAutomatico === "SEMPRE" || aceiteAutomatico === "TELA_ABERTA"
    const isElectron = typeof navigator !== "undefined" && navigator.userAgent.includes("Electron")

    // Migração ao vivo: o modo "Operação automática (só com o Painel)" (TELA_ABERTA) foi
    // removido. Quem estava nele (estado re-hidratado do "app-store") é redirecionado para
    // "Operação automática" (SEMPRE) assim que as configs carregam.
    useEffect(() => {
        if (configs?.recebedor?.aceiteAutomatico === "TELA_ABERTA")
            atualizarConfiguracoes({ recebedor: { aceiteAutomatico: "SEMPRE" } })
    }, [configs?.recebedor?.aceiteAutomatico, atualizarConfiguracoes])


    // QZ não configurado (impressão via navegador forçada OU nenhuma impressora
    // selecionada). O aviso aparece em QUALQUER status operacional, exceto em
    // Visualização (onde nada é impresso). O clique abre a tela de configuração.
    // Garçom (como Visualização) não imprime nesta estação: não faz sentido cobrar
    // configuração de impressora no celular do garçom — a comanda sai na estação da loja.
    const qzNaoConfigurado = !emVisualizacao && !emModoGarcom && !qzConfigurado
    // Distingue os dois motivos de "não configurado": quando o QZ está escolhido
    // (não forçou o navegador) mas nenhuma impressora foi selecionada, o problema é a
    // impressora — não o QZ. A mensagem do banner reflete isso para não confundir o
    // usuário que já tem o QZ selecionado (ver print "QZ (Automática)" sem impressora).
    const qzSemImpressora =
        qzNaoConfigurado &&
        !forcarImpressaoNavegador() &&
        (configs?.printer?.impressoras?.length ?? 0) === 0
    const mensagemNaoConfigurado = qzSemImpressora
        ? "Impressora não configurada"
        : "Impressão em modo manual"
    const complementoNaoConfigurado = qzSemImpressora
        ? " — clique para configurar"
        : " - clique para configurar a impressão automática"

    // Dispensa do aviso de impressora não configurada: mesma lógica da fatura (ver
    // abaixo) — em sessionStorage, não localStorage, para o aviso voltar na próxima
    // sessão do navegador em vez de silenciar para sempre uma impressora que
    // continua sem configurar.
    const [avisoImpressoraDispensado, setAvisoImpressoraDispensado] = useState(
        sessionStorage.getItem("aviso-impressora-dispensado") === "true"
    )
    const dispensarAvisoImpressora = () => {
        sessionStorage.setItem("aviso-impressora-dispensado", "true")
        setAvisoImpressoraDispensado(true)
    }
    const mostrarAvisoImpressora = qzNaoConfigurado && !avisoImpressoraDispensado

    // Módulo de impressão (QZ) não encontrado em execução. Faz sentido sempre que o QZ
    // JÁ está configurado (impressora selecionada), fora do Electron, mas o módulo não
    // está ativo agora — vale tanto no modo automático (o pedido precisa sair sozinho)
    // quanto no manual (o clique em imprimir vai cair para a impressão pelo navegador).
    // Como o polling acima mantém o QZ conectado quando há impressora configurada,
    // `!qzAtivo` só permanece verdadeiro quando o módulo está realmente fechado. Quando
    // o QZ nem está configurado, o aviso `qzNaoConfigurado` (acima) é o mais adequado —
    // ele exige `!qzConfigurado`, então os dois nunca aparecem juntos.
    // Dispensa da faixa "Módulo de impressão não encontrado": em sessionStorage (volta
    // na próxima sessão do navegador), mesmo critério do aviso de impressora.
    const [alertaImpressaoDispensado, setAlertaImpressaoDispensado] = useState(
        sessionStorage.getItem("alerta-impressao-dispensado") === "true"
    )
    const dispensarAlertaImpressao = () => {
        sessionStorage.setItem("alerta-impressao-dispensado", "true")
        setAlertaImpressaoDispensado(true)
    }
    const mostrarAlertaImpressao =
        !emVisualizacao &&
        !emModoGarcom &&
        !isElectron &&
        !qzAtivo &&
        qzConfigurado &&
        !alertaImpressaoDispensado

    // [IMPRESSAO-DEBUG] Mostra por que a faixa (não) aparece. REMOVER depois.
    useEffect(() => {
        console.log(
            "%c[FAIXA]",
            "color:#c0392b;font-weight:bold",
            "qzAtivo:",
            qzAtivo,
            "| qzConfigurado:",
            qzConfigurado,
            "| impressorasSalvas:",
            configs?.printer?.impressoras?.length ?? 0,
            "| forcarNavegador:",
            forcarImpressaoNavegador(),
            "| emVisualizacao:",
            emVisualizacao,
            "| aceite:",
            aceiteAutomatico,
            "| mostrarAlertaImpressao:",
            mostrarAlertaImpressao,
            "| mostrarAvisoImpressora:",
            mostrarAvisoImpressora,
            "| avisoDispensado:",
            avisoImpressoraDispensado
        )
    }, [
        qzAtivo,
        qzConfigurado,
        emVisualizacao,
        aceiteAutomatico,
        mostrarAlertaImpressao,
        mostrarAvisoImpressora,
        avisoImpressoraDispensado,
        configs?.printer?.impressoras?.length,
    ])

    // Avisos de FATURA (mesma origem do DialogAvisoFatura, lidos do custom-params).
    // Antes eram faixas fixas no rodapé; agora entram no mesmo "stack" do topo, com o
    // estilo padrão. O clique abre o diálogo de faturas (evento "abrirFaturas", ouvido
    // pelo DialogAvisoFatura).
    //
    // A dispensa fica em sessionStorage (não localStorage): vale só enquanto a aba
    // estiver aberta e a faixa volta na próxima sessão do navegador. Em localStorage
    // a chave nunca era limpa, então um clique no X silenciava o aviso para sempre,
    // em todas as lojas e para toda fatura futura.
    const [faturaDispensada, setFaturaDispensada] = useState(
        sessionStorage.getItem("pop-up-fatura-aberta") === "false"
    )
    const faturaParams = (() => {
        try {
            return JSON.parse(localStorage.getItem("custom-params") || "{}") || {}
        } catch {
            return {}
        }
    })()
    // Valores possíveis de GENERATED_ASSINATURA_STATUS (Assinatura.getDescricaoStatus,
    // no sistemaadm): Inativa, Ativa, Bloqueada, Isenta, Pendente, Ativa Vinculada,
    // Não definido. O parâmetro é omitido quando a loja não tem assinatura.
    const faturaBloqueada =
        faturaParams?.GENERATED_ASSINATURA_STATUS === "Bloqueada" ||
        faturaParams?.GENERATED_ASSINATURA_STATUS === "Inativa"
    // Faixa "Sua fatura já foi gerada": assunto financeiro/administrativo. Só aparece para
    // perfil administrador e nunca no terminal do garçom (o celular do garçom não trata
    // fatura).
    const faturaAberta =
        perfilAdm &&
        !emModoGarcom &&
        !faturaBloqueada &&
        !!faturaParams?.GENERATED_POSSUI_FATURA_ABERTA &&
        !faturaDispensada
    const abrirFaturas = () => window.dispatchEvent(new CustomEvent("abrirFaturas"))
    const dispensarFatura = () => {
        sessionStorage.setItem("pop-up-fatura-aberta", "false")
        setFaturaDispensada(true)
    }

    // As faixas ficam DENTRO do AppBar (fixo), então empurramos o conteúdo da página
    // para baixo aplicando um padding-top no <body> igual à altura do STACK de faixas
    // — assim elas não sobrepõem o conteúdo. O header fixo não é afetado por padding
    // do body (posiciona-se pela viewport). Um ResizeObserver reaplica quando qualquer
    // faixa aparece/some/quebra de linha; zera quando o stack fica vazio.
    const bannerStackRef = useRef(null)
    useEffect(() => {
        const el = bannerStackRef.current
        if (!el) return
        const aplicar = () => {
            const h = el.offsetHeight || 0
            document.body.style.paddingTop = h ? `${h}px` : ""
            document.documentElement.style.setProperty("--banner-height", `${h}px`)
        }
        aplicar()
        let ro
        if (typeof ResizeObserver !== "undefined") {
            ro = new ResizeObserver(aplicar)
            ro.observe(el)
        }
        window.addEventListener("resize", aplicar)
        return () => {
            if (ro) ro.disconnect()
            window.removeEventListener("resize", aplicar)
            document.body.style.paddingTop = ""
            document.documentElement.style.setProperty("--banner-height", "0px")
        }
    }, [])

    const [dialogSair, setDialogSair] = useState(false)
    const handleSair = () => {
        clearWhatsappOfficialSession()
        localStorage.removeItem("chaveSistema")
        localStorage.removeItem("dataUltimoServico")
        localStorage.removeItem("estabelecimentoAtualCF")
        window.name = ""
        history.push("/login")
    }

    // Abre a tela de cadastro de bairros conforme o modo de entrega do restaurante.
    // Delega para o handleBairros do permissoes, que e a fonte unica da regra do
    // LayoutFornecedorMENU (calculoEntrega > 0 -> Faixas; tipoEntregaBairro 1 ->
    // especifico /bairros; senao -> padrao /atribuir-bairros) e ainda busca os
    // parametros da loja selecionada no caso multi-loja.
    const handleAreaEntrega = () => {
        handleBairros()
    }

    // ── Estrutura do menu espelhando o Sistema Administrativo ──
    // Fonte única usada pela sidebar expandida, pela mini (ícones) e pelo submenu.
    const secoes = [
        {
            key: "inicio",
            label: "Início",
            icon: <Dashboard />,
            gate: perfilCompleto,
            onClick: handleHome,
        },
        {
            key: "pedidos",
            label: "Pedidos",
            icon: <RoomService />,
            gate: true,
            items: [
                { label: "Recebimento de pedidos", onClick: handleAceitadorDePedidos },
                {
                    label: "Pedidos do Dia",
                    onClick: () => history.push("/servicos/modulo/pedidos-do-dia"),
                    gate: perfilPedidosDia,
                },
                {
                    label: "Roteirização",
                    onClick: () => history.push("/servicos/modulo/roteirizacao"),
                    gate: perfilCompleto,
                    novo: true,
                },
                { label: "Registrador de pedidos", onClick: () => handleRegistradorDePedidos() },
                { label: "Pedidos de mesa", onClick: handlePedidoDeMesa },
                { label: "Histórico de mesas", onClick: handleHistoricoMesas, gate: perfilAdm },
                {
                    label: "Histórico de Pedidos",
                    onClick: () => history.push("/servicos/modulo/historico-pedidos"),
                    gate: perfilAdm,
                },
                // Caixa disponível no submenu de Pedidos para todos os perfis
                // (perfis completos também mantêm o Caixa na seção Financeiro)
                { label: "Caixa", onClick: handleCaixa },
            ],
        },
        {
            key: "cardapio",
            label: "Cardápio",
            icon: <MenuBook />,
            gate: perfilCardapio,
            items: [
                { label: "Produtos", onClick: handleCardapio },
                { label: "Edição em Massa", onClick: handleCardapioMassa },
                { label: "Estoque", onClick: handleCardapioInsumos },
                { label: "Fichas Técnicas", onClick: handleCardapioFichaTecnica },
                { label: "Histórico", onClick: handleCardapioHistorico },
                { label: "Galeria", onClick: handleGaleria },
            ],
        },
        {
            key: "cadastro",
            label: "Cadastro",
            icon: <AddBox />,
            gate: perfilCompleto,
            items: [
                {
                    label: "Dados do estabelecimento",
                    onClick: () => history.push("/servicos/modulo/dados-estabelecimento"),
                },
                { label: "Importar clientes", onClick: handleImportarClientes },
                { label: "Endereços bloqueados", onClick: handleEnderecosBloqueados },
                { label: "Telefones bloqueados", onClick: handleTelefonesBloqueados },
                { label: "Entregadores", onClick: handleEntregadores },
                { label: "Área de Entrega", onClick: handleAreaEntrega },
                { label: "Ver Mapa de Área de Entrega", onClick: handleAreaDeEntrega },
                { label: "Formas de pagamento", onClick: handleFormasDePagamento },
                { label: "Turnos de entrega", onClick: handleTurnos },
                { label: "PDVoz", onClick: handlePDVoz },
            ],
        },
        {
            key: "delivery",
            label: "Configurações",
            icon: <Settings />,
            gate: perfilCompleto,
            items: [
                { label: "Parâmetros do delivery", onClick: handleParametrosDelivery },
                { label: "Parâmetros avançados", onClick: handleParametrosAvancados },
                { label: "Parâmetros de integração", onClick: handleIntegracoes },
                { label: "Preferências de impressão", onClick: handlePreferenciasImpressao },
                { subheader: "Exclusivo Cliente Fiel", gate: perfilClienteFiel },
                {
                    label: "Parâmetros gerais",
                    onClick: handleParametros,
                    gate: perfilClienteFiel,
                    exclusivo: true,
                },
                {
                    label: "Parâmetros Cliente Fiel",
                    onClick: handleParametrosClienteFiel,
                    gate: perfilClienteFiel,
                    exclusivo: true,
                },
            ],
        },
        {
            key: "estrategias",
            label: "Estratégias / Marketing",
            labelMini: "Estratégias",
            icon: <TrendingUp />,
            gate: perfilCompleto,
            items: [
                { label: "Estratégias", onClick: handleEstrategias },
                { label: "Promoção de fidelidade", onClick: handlePromocaoFidelidade },
                { label: "Promoções", onClick: handlePromocoes },
                {
                    label: "Cupom de desconto/incentivo",
                    onClick: handleCuponsDesconto,
                    gate: perfilAdm,
                },
                { label: "Banner", onClick: handleBanners, gate: perfilAdm },
                {
                    label: "Marketing automático",
                    onClick: handleMarketingAutomatico,
                    gate: perfilAdm,
                },
                { label: "Indicação de amigos", onClick: handleIndicacoesAmigos },
            ],
        },
        {
            key: "financeiro",
            label: "Financeiro",
            icon: <MonetizationOn />,
            gate: perfilCompleto,
            items: [
                { label: "Caixa", onClick: handleCaixa },
                { label: "Configuração Fiscal", onClick: handleConfiguracaoFiscal },
                { label: "Emissão Cupom Fiscal", onClick: handleEmissaoCupomFiscal },
                { label: "Emissão fiscal", onClick: handleNotaFiscal },
                { label: "Emissões para Meu CNPJ", onClick: handleEmissoesParaMeuCNPJ },
                { label: "Extrato Detalhado (PIX)", onClick: handleExtratoDetalhado },
                { label: "Extrato Pagarme", onClick: handleExtratoPagarme },
                { label: "Histórico de Caixa", onClick: handleHistoricoCaixa },
                { label: "Histórico de Fechamentos", onClick: handleHistoricoFechamentos },
            ],
        },
        {
            key: "notificacoes",
            label: "Notificações / WhatsApp",
            labelMini: "Notificações",
            icon: <WhatsApp />,
            novo: true,
            gate: perfilCompleto,
            items: [
                { subheader: "Push" },
                { label: "Notificação Push", onClick: handleNotificacaoPush, novo: true },
                { label: "Notificações", onClick: handleNotificacoes },
                { subheader: "WhatsApp" },
                { label: "API oficial WhatsApp", onClick: handleIntegracaoWhatsapp },
                { label: "Conversas do WhatsApp", onClick: handleConversasWhatsapp },
                {
                    label: "Respostas personalizadas (Izza)",
                    onClick: handleRespostasPersonalizadasIzza,
                },
                { label: "Modelo Izza GPT", onClick: handleModeloIzzaGPT, gate: perfilAdm },
                { label: "Envios Izza", onClick: handleEnviosIzza },
            ],
        },
        {
            key: "agendamento",
            label: "Agendamento",
            icon: <AccessAlarm />,
            novo: true,
            // Menu de agendamento sempre disponível (não depende de PUBLIC_HABILITAR_AGENDAMENTO);
            // fica com o mesmo gate de perfil das demais seções.
            gate: perfilCompleto,
            items: [
                { label: "Pedidos agendados", onClick: handlePedidosAgendados },
                { label: "Períodos de agendamento", onClick: handleAgendamentoPeriodos },
                { label: "Configurações de agendamento", onClick: handleAgendamentoConfiguracoes },
            ],
        },
        {
            key: "consultas",
            label: "Consultas",
            icon: <LocationSearching />,
            gate: perfilCompleto,
            items: [
                { label: "Desempenho", onClick: handleResumo },
                { label: "Clientes", onClick: handleClientes },
                { label: "Pedidos", onClick: handleRelatorioPedidos },
                { label: "Produtos mais vendidos", onClick: handleListarProdutos },
                { label: "Cartelas de fidelidade", onClick: handleCartelas },
                { label: "Comparativo de unidades", onClick: handleComparativoUnidades },
                { label: "Posição de clientes", onClick: handlePosicaoClientes },
                { label: "Histórico de mesas", onClick: handleHistoricoMesas },
                { label: "Avaliação de pedidos", onClick: handleAvaliacaoDelivery },
            ],
        },
        {
            key: "utilitarios",
            label: "Administração",
            icon: <SettingsApplications />,
            gate: perfilCompleto,
            items: [
                { subheader: "Cadastros", gate: perfilClienteFiel },
                {
                    label: "Cadastrar novo cliente",
                    onClick: () => window.open("/comece-agora", "_blank", "noopener"),
                    novaAba: true,
                    gate: perfilClienteFiel,
                    exclusivo: true,
                },
                {
                    label: "Alertas do painel",
                    onClick: () => history.push("/servicos/modulo/alertas-painel"),
                    gate: perfilClienteFiel,
                    exclusivo: true,
                },
                { subheader: "Utilitários" },
                { label: "Atendente Virtual (Izza)", onClick: handleIzzaBot },
                { label: "Gerar QRCodes de Mesa", onClick: handleQRCodesMesa },
                { label: "Gerador de QrCode", onClick: handleGeradorQrCode },
                { label: "Histórico Versões", onClick: handleHistoricoVersoes },
                {
                    label: "Impressões do dia",
                    onClick: () => history.push("/servicos/modulo/impressoes-do-dia"),
                },
                { subheader: "Integrações" },
                {
                    label: "Integração Open Delivery",
                    onClick: handleIntegracaoOpenDelivery,
                    gate: perfilAdm,
                    novo: true,
                },
                {
                    label: "Testar Open Delivery",
                    onClick: handleTestarOpenDelivery,
                    gate: perfilAdm,
                    novo: true,
                },
                {
                    label: "Integradores Open Delivery",
                    onClick: handleOpenDeliveryIntegradores,
                    gate: perfilClienteFiel,
                    exclusivo: true,
                },
                {
                    label: "Usuários",
                    onClick: handleUsuariosPainel,
                    gate: perfilClienteFiel,
                    exclusivo: true,
                },
                {
                    label: "Assinatura",
                    onClick: handleAssinatura,
                    gate: perfilCompleto,
                },
                { subheader: "Parâmetros" },
                {
                    label: "Parâmetros gerais",
                    onClick: handleParametros,
                    gate: perfilClienteFiel,
                    exclusivo: true,
                },
            ],
        },
    ]

    const secoesVisiveis = secoes.filter(s => s.gate !== false)

    const [submenu, setSubmenu] = useState({ secao: null, anchor: null })
    const fecharSubmenu = () => setSubmenu({ secao: null, anchor: null })
    const acionarSecao = (secao, e) => {
        if (secao.items) setSubmenu({ secao, anchor: e.currentTarget })
        else secao.onClick?.()
    }

    // Rota de cada item de menu (por rótulo), para renderizar os itens como links (<a href>)
    // e permitir clicar com o botão direito / ctrl / meio e abrir em nova aba.
    const caminhoInicio = perfilCompleto ? "/servicos/modulo/resumo?inicial=1" : "/servicos"
    const rotaMenu = {
        // Pedidos
        "Recebimento de pedidos": "/servicos/modulo/recebedor-de-pedidos",
        "Pedidos do Dia": "/servicos/modulo/pedidos-do-dia",
        Roteirização: "/servicos/modulo/roteirizacao",
        "Registrador de pedidos": "/servicos/modulo/registrador-de-pedidos",
        "Pedidos de mesa": "/servicos/modulo/gerenciador-de-mesas",
        "Histórico de mesas": "/servicos/modulo/historico-mesas",
        "Histórico de Pedidos": "/servicos/modulo/historico-pedidos",
        Caixa: "/servicos/modulo/caixa",
        // Cardápio
        Produtos: "/servicos/ferramenta/edicao-cardapio/produtos",
        "Edição em Massa": "/servicos/ferramenta/edicao-cardapio/massa",
        Estoque: "/servicos/ferramenta/edicao-cardapio/insumos",
        "Fichas Técnicas": "/servicos/ferramenta/edicao-cardapio/ficha-tecnica",
        Histórico: "/servicos/ferramenta/edicao-cardapio/historico",
        Galeria: "/servicos/ferramenta/galeria",
        // Cadastro
        "Dados do estabelecimento": "/servicos/modulo/dados-estabelecimento",
        "Importar clientes": "/importacao-clientes",
        "Endereços bloqueados": "/servicos/modulo/enderecos-bloqueados",
        "Telefones bloqueados": "/servicos/modulo/telefones-bloqueados",
        "Integração Open Delivery": "/servicos/modulo/integracao-opendelivery",
        "Testar Open Delivery": "/servicos/modulo/testar-opendelivery",
        "Integradores Open Delivery": "/servicos/modulo/opendelivery-integradores",
        Usuários: "/servicos/modulo/usuarios",
        Assinatura: "/servicos/modulo/assinatura",
        Entregadores: "/servicos/modulo/entregadores",
        "Formas de pagamento": "/configuracao-formas-pagamento",
        "Turnos de entrega": "/servicos/modulo/horarios-delivery",
        // Configurações
        "Parâmetros do delivery": "/servicos/modulo/configuracao-delivery/parametros-delivery",
        "Parâmetros avançados": "/servicos/modulo/configuracao-delivery/parametros-avancados",
        "Parâmetros gerais": "/servicos/modulo/parametros-gerais",
        "Parâmetros de integração": "/servicos/modulo/configuracao-delivery/parametros-integracao",
        "Parâmetros Cliente Fiel": "/servicos/modulo/configuracao-delivery/parametros-cliente-fiel",
        "Preferências de impressão": "/servicos/modulo/texto-impressao",
        // Estratégias / Marketing
        Estratégias: "/servicos/modulo/estrategias",
        "Promoção de fidelidade": "/servicos/modulo/promocao-fidelidade",
        Promoções: "/promocoes",
        "Cupom de desconto/incentivo": "/cupons/desconto",
        Banner: "/servicos/modulo/banners",
        "Marketing automático": "/marketing/marketing-automatico",
        "Indicação de amigos": "/servicos/modulo/indicacoes-amigos",
        // Notificações / WhatsApp
        "API oficial WhatsApp": "/servicos/modulo/integracao-whatsapp",
        Notificações: "/notificacoes",
        "Notificação Push": "/servicos/modulo/notificacao-push",
        "Conversas do WhatsApp": "/servicos/modulo/conversas-whatsapp",
        "Criar template WhatsApp": "/servicos/modulo/criar-template-whatsapp",
        "Envio template (grupo)": "/servicos/modulo/envio-template-whatsapp-grupo",
        "Respostas personalizadas (Izza)": "/servicos/modulo/respostas-personalizadas-izza",
        "Modelo Izza GPT": "/servicos/modulo/modelo-izza-gpt",
        "Envios Izza": "/servicos/modulo/envios-izza",
        // Consultas
        Desempenho: "/servicos/modulo/resumo",
        Clientes: "/clientes",
        Pedidos: "/relatorio-pedidos",
        "Produtos mais vendidos": "/servicos/modulo/listar-produtos",
        "Cartelas de fidelidade": "/cartelas",
        "Comparativo de unidades": "/servicos/modulo/comparativo-unidades",
        "Posição de clientes": "/posicao-clientes",
        "Avaliação de pedidos": "/avaliacao-delivery",
        // Financeiro
        "Configuração Fiscal": "/fiscal/configuracao-fiscal",
        "Emissão Cupom Fiscal": "/fiscal/emissao-cupom-fiscal",
        "Emissões para Meu CNPJ": "/fiscal/emissoes-para-meu-cnpj",
        "Extrato Detalhado (PIX)": "/pix/extrato-detalhado",
        "Extrato Pagarme": "/pix/extrato-pagarme",
        "Histórico de Caixa": "/servicos/modulo/historico-caixa",
        "Histórico de Fechamentos": "/servicos/modulo/historico-fechamentos",
        // Agendamento
        "Pedidos agendados": "/servicos/modulo/pedidos-agendados",
        "Períodos de agendamento": "/servicos/modulo/agendamento-periodos",
        "Configurações de agendamento": "/servicos/modulo/agendamento-configuracoes",
        // Utilitários
        "Gerar QRCodes de Mesa": "/servicos/modulo/pedido-de-mesa",
        "Gerador de QrCode": "/servicos/modulo/gerador-de-qrcode",
        "Histórico Versões": "/historico-versoes",
        "Impressões do dia": "/servicos/modulo/impressoes-do-dia",
        // Cadastros
        "Cadastrar novo cliente": "/comece-agora",
        "Alertas do painel": "/servicos/modulo/alertas-painel",
    }
    const rotaDaSecao = secao =>
        secao.items ? undefined : secao.key === "inicio" ? caminhoInicio : rotaMenu[secao.label]
    const rotaDoItem = item => rotaMenu[item.label]

    // Cliques com modificador (ctrl/cmd/shift) deixam o navegador abrir em nova aba;
    // o clique simples navega pela SPA (executa o handler original).
    const clicarLink = (e, path, acao) => {
        if (path && (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) return
        if (path) e.preventDefault()
        acao?.()
    }

    const menuContent = () => {
        if (isPerfilWhatsappOperador) {
            return (
                <>
                    <List className={classes.lista}>
                        {perfilCompleto && (
                            <ListItem
                                button
                                onClick={() => {
                                    handleHome()
                                }}
                            >
                                <div
                                    style={{ display: "flex", alignItems: "center", width: "100%" }}
                                >
                                    <div className={classes.listItemIcon}>
                                        <Dashboard />
                                    </div>
                                    <ListItemText primary="Menu" className={classes.listItemText} />
                                </div>
                            </ListItem>
                        )}
                        <ListItem button onClick={() => handleConversasWhatsapp()}>
                            <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                                <div className={classes.listItemIcon}>
                                    <Chat />
                                </div>
                                <ListItemText primary="Chat" className={classes.listItemText} />
                            </div>
                        </ListItem>
                        <ListItem button onClick={() => handleCriarTemplateWhatsapp()}>
                            <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                                <div className={classes.listItemIcon}>
                                    <PostAdd />
                                </div>
                                <ListItemText
                                    primary="Cadastrar templates"
                                    className={classes.listItemText}
                                />
                            </div>
                        </ListItem>
                        <ListItem button onClick={() => handleEnvioTemplateWhatsappGrupo()}>
                            <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                                <div className={classes.listItemIcon}>
                                    <Send />
                                </div>
                                <ListItemText
                                    primary="Disparar templates"
                                    className={classes.listItemText}
                                />
                            </div>
                        </ListItem>
                        <ListItem button onClick={() => handleDadosFornecedor()}>
                            <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                                <div className={classes.listItemIcon}>
                                    <AccountCircle />
                                </div>
                                <ListItemText
                                    primary="Minha Conta"
                                    className={classes.listItemText}
                                />
                            </div>
                        </ListItem>
                    </List>
                </>
            )
        }

        return (
            <>
                <List className={classes.lista}>
                    {/* <ListItem button onClick={handleFatura} className={classes.billBanner}>
                        <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
                            Fatura Disponível
                        </Typography>
                    </ListItem> */}

                    {secoesVisiveis.map(secao => {
                        const path = rotaDaSecao(secao)
                        return (
                            <ListItem
                                button
                                key={secao.key}
                                component={path ? "a" : "div"}
                                href={path}
                                onClick={e => clicarLink(e, path, () => acionarSecao(secao, e))}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        width: "100%",
                                    }}
                                >
                                    <div className={classes.listItemIcon}>{secao.icon}</div>
                                    <ListItemText
                                        primary={secao.label}
                                        className={classes.listItemText}
                                    />
                                    {secao.novo && (
                                        <Chip
                                            size="small"
                                            label="novo"
                                            style={{
                                                height: 18,
                                                marginLeft: 8,
                                                fontSize: 10,
                                                fontWeight: "bold",
                                                textTransform: "uppercase",
                                                backgroundColor: "#e53935",
                                                color: "#fff",
                                            }}
                                        />
                                    )}
                                </div>
                                {secao.items && <ChevronRight style={{ opacity: 0.6 }} />}
                            </ListItem>
                        )
                    })}
                </List>
            </>
        )
    }

    return (
        <>
            <Dialog open={dialogSair} onClose={() => setDialogSair(false)}>
                <DialogTitle>Deseja sair da sua conta?</DialogTitle>
                <DialogContent>
                    <Typography>
                        Você está prestes a encerrar sua sessão. Para continuar usando o painel,
                        será necessário fazer login novamente.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        style={{ backgroundColor: "green", color: "white" }}
                        onClick={() => {
                            setDialogSair(false)
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        variant="contained"
                        style={{ backgroundColor: "red", color: "white" }}
                        onClick={handleSair}
                    >
                        Sair
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={dialogImpressao} onClose={() => setDialogImpressao(false)}>
                <DialogTitle>
                    <ReportProblemOutlined
                        style={{ color: "#f5a623", verticalAlign: "middle", marginRight: 8 }}
                    />
                    Módulo de impressão não encontrado
                </DialogTitle>
                <DialogContent>
                    <Typography gutterBottom>
                        Não foi encontrado o módulo de impressão (QZ) em execução nesta máquina.
                    </Typography>
                    <Typography gutterBottom>
                        Ele é{" "}
                        <strong>importante para o funcionamento da impressão automática</strong>,
                        que imprime os pedidos <strong>sem nenhuma ação do usuário</strong> enquanto
                        o painel está em modo automático. Sem ele, os pedidos podem ser aceitos mas
                        <strong> não serão impressos automaticamente</strong>.
                    </Typography>
                    <Typography gutterBottom>
                        Baixe e instale o módulo, deixe-o em execução e volte a esta tela:
                    </Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        href={URL_MODULO_IMPRESSAO}
                        target="_blank"
                        rel="noopener noreferrer"
                        startIcon={<GetApp />}
                    >
                        Baixar módulo de impressão
                    </Button>
                    <Typography variant="body2" style={{ marginTop: 12 }}>
                        Precisa de ajuda para instalar?{" "}
                        <a
                            href={URL_INSTRUCOES_IMPRESSAO}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Ver instruções de instalação
                        </a>
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialogImpressao(false)}>Fechar</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={dialogConfigImpressao}
                onClose={() => setDialogConfigImpressao(false)}
                maxWidth="md"
                fullWidth
            >
                <ConfiguracaoImpressao onFechar={() => setDialogConfigImpressao(false)} />
            </Dialog>
            <DialogTrocaEstabelecimento
                open={openDialogAlterarEstabelecimento}
                onClose={handleToggleDialogAlterarEstabelecimento}
            />
            <DialogAlertas
                alertas={alertasSistema}
                abrirAlertas={abrirAlertas}
                setAbrirAlertas={fecharAlertas}
            />
            <div className={classes.root} id="cabecalhoApp">
                <AppBar
                    position="fixed"
                    className={clsx(classes.appBar, {
                        [classes.appBarShift]: openBarraLateral,
                    })}
                >
                    <Toolbar
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            maxWidth: "100vw",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                minWidth: 0,
                                flex: telaEstreita ? 1 : undefined,
                            }}
                        >
                            {mobile && (
                                <IconButton
                                    color="inherit"
                                    aria-label="open drawer"
                                    onClick={handleMobileDrawerToggle}
                                    className={classes.menuButton}
                                    size="small"
                                >
                                    <Menu />
                                </IconButton>
                            )}

                            {icone && (
                                <div
                                    className={classes.iconeImg}
                                    color="inherit"
                                    aria-label="open drawer"
                                >
                                    <img
                                        src={icone}
                                        style={{
                                            height: "50px",
                                            borderRadius: "100%",
                                        }}
                                        alt=""
                                    />
                                </div>
                            )}
                            {/* Seletor de modo (Operação/Visualização) — presente em todas as telas.
                                flexShrink: 0 mantém o seletor legível quando o título encolhe.
                                O botão de situação da loja (Aberto/Fechado) vem logo depois: as
                                duas coisas respondem "como a loja está operando agora". */}
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                    marginLeft: telaEstreita ? "0.5em" : "1em",
                                    flexShrink: 0,
                                }}
                            >
                                <Button
                                    size="small"
                                    onClick={e => setAnchorModo(e.currentTarget)}
                                    style={{
                                        color: "white",
                                        textTransform: "none",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    <span
                                        style={{
                                            width: 10,
                                            height: 10,
                                            borderRadius: "50%",
                                            marginRight: 6,
                                            backgroundColor: corModo,
                                            display: "inline-block",
                                            flexShrink: 0,
                                        }}
                                    />
                                    {telaEstreita ? rotuloModoCurto : `Operação: ${rotuloModo}`}
                                    <ArrowDropDown fontSize="small" />
                                </Button>
                                <Popover
                                    open={Boolean(anchorModo)}
                                    anchorEl={anchorModo}
                                    onClose={() => setAnchorModo(null)}
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    transformOrigin={{ vertical: "top", horizontal: "left" }}
                                >
                                    <List dense style={{ maxWidth: 360 }}>
                                        {opcoesModo.map(opcao => (
                                            <ListItem
                                                key={opcao.id}
                                                button
                                                disabled={opcao.disabled}
                                                selected={modoAtual === opcao.id}
                                                onClick={() => selecionarModo(opcao.id)}
                                                alignItems="flex-start"
                                            >
                                                <span
                                                    style={{
                                                        width: 12,
                                                        height: 12,
                                                        borderRadius: "50%",
                                                        marginTop: 4,
                                                        marginRight: 10,
                                                        backgroundColor: opcao.cor,
                                                        display: "inline-block",
                                                        flexShrink: 0,
                                                    }}
                                                />
                                                <ListItemText
                                                    primary={opcao.titulo}
                                                    secondary={opcao.descricao}
                                                />
                                            </ListItem>
                                        ))}
                                        {/* Preparar pedidos automaticamente: fica junto do modo
                                            porque só se aplica ao aceite automático. Desabilitado
                                            (mas visível) fora do modo automático. */}
                                        <Divider component="li" style={{ margin: "4px 0" }} />
                                        <ListItem alignItems="flex-start" disabled={!preparoDisponivel}>
                                            <ListItemText
                                                primary="Preparar pedidos automaticamente"
                                                secondary={
                                                    preparoDisponivel
                                                        ? "Coloca os pedidos aceitos direto em preparo, sem clique."
                                                        : "Disponível apenas na Operação automática."
                                                }
                                            />
                                            <Switch
                                                edge="end"
                                                color="primary"
                                                checked={preparoAutomatico}
                                                disabled={!preparoDisponivel}
                                                onChange={alternarPreparo}
                                                inputProps={{
                                                    "aria-label": "Preparar pedidos automaticamente",
                                                }}
                                            />
                                        </ListItem>
                                    </List>
                                </Popover>

                                {/* No mobile o botão daria transbordo; lá a situação aparece como
                                    o pontinho colorido da BarraPerfil. */}
                                {!telaEstreita && <BotaoStatusLoja />}

                                {/* Selo "esta aba imprime": só UMA aba por navegador é a
                                    impressora (eleição em impressaoLider). O 🖨️ no título da
                                    aba nem sempre fica visível, então fica aqui, junto do
                                    status de operação (e não entre os ícones de ação).
                                    No modo Garçom não faz sentido: essa estação não imprime
                                    (a comanda sai na estação da loja). */}
                                {souImpressora && !emModoGarcom && (
                                    <Tooltip
                                        arrow
                                        title="Esta aba é a que imprime as comandas neste navegador (impressora líder)."
                                    >
                                        <span
                                            style={{
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: 26,
                                                height: 26,
                                                borderRadius: "50%",
                                                backgroundColor: "rgba(255,255,255,0.18)",
                                                border: "1px solid rgba(255,255,255,0.35)",
                                                flexShrink: 0,
                                            }}
                                        >
                                            <Print fontSize="small" style={{ color: "#fff" }} />
                                        </span>
                                    </Tooltip>
                                )}
                            </div>
                        </div>

                        {/* Título da tela, centralizado entre o cluster de operação (esquerda) e o
                            de ações/perfil (direita). Em telas estreitas ele é omitido para caber
                            todos os controles; a tela é identificada pelo conteúdo e pelo menu. */}
                        {!telaEstreita && (
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    flex: 1,
                                    minWidth: 0,
                                    padding: "0 1em",
                                }}
                            >
                                <Typography className={classes.title} variant="h6" noWrap>
                                    {pagina}{" "}
                                    {subtitulo && (
                                        <span style={{ fontSize: "50%", color: "gray" }}>
                                            {subtitulo}
                                        </span>
                                    )}
                                </Typography>
                            </div>
                        )}

                        <div style={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
                            {desconectar && (
                                <IconButton
                                    color="inherit"
                                    aria-label="open drawer"
                                    edge="end"
                                    onClick={desconectar}
                                >
                                    <ExitToAppIcon />
                                </IconButton>
                            )}
                            {registrarPedidoMesa && (
                                <IconButton
                                    color="inherit"
                                    aria-label="open drawer"
                                    edge="end"
                                    onClick={registrarPedidoMesa}
                                >
                                    Registrar
                                </IconButton>
                            )}
                            {trocarEstabelecimento && (
                                <Button onClick={() => handleQRCodesMesa()} variant="contained">
                                    <span className="no-mobile">Gerar</span> QRCodes
                                </Button>
                            )}

                            {/* O áudio de novo pedido (#audiopedido) não vive mais aqui:
                                era criado e destruído junto com o Cabeçalho. Agora é um
                                elemento único por aba, criado no body pelo
                                useOperacaoTempoReal. */}

                            {/* Modo Garçom: atalhos diretos para o que o garçom realmente
                                usa — lançar pedido (Registrador) e mesas. SÓ no mobile: no
                                desktop a BarraPerfil já mostra esses ícones (onRegistrador/
                                onMesas), então renderizá-los aqui também os DUPLICAVA. */}
                            {emModoGarcom && mobile && (
                                <>
                                    <Tooltip arrow title="Abrir registrador de pedidos">
                                        <IconButton
                                            color="inherit"
                                            onClick={() => handleRegistradorDePedidos()}
                                        >
                                            <Edit />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip arrow title="Abrir tela de mesas">
                                        <IconButton
                                            color="inherit"
                                            onClick={handlePedidoDeMesa}
                                        >
                                            <Deck />
                                        </IconButton>
                                    </Tooltip>
                                </>
                            )}

                            {/* Bandeja de recebimento de pedidos: no modo Garçom não é
                                relevante (essa estação não recebe/aceita pedidos), então
                                fica oculta para dar lugar aos atalhos Registrador/Mesa. */}
                            {!emModoGarcom && (
                                <Tooltip
                                    arrow
                                    title={
                                        novoPedidoRecente
                                            ? "Novo pedido recebido! Abrir recebimento"
                                            : "Recebimento de pedidos"
                                    }
                                >
                                    <IconButton
                                        className={classes.botaoNovoPedido}
                                        onClick={() => {
                                            setNovoPedidoRecente(false)
                                            // Para o som em TODAS as abas do navegador, não só
                                            // nesta — cada aba toca seu próprio <audio>.
                                            silenciarAvisoTodasAbas()
                                            handleAceitadorDePedidos()
                                        }}
                                    >
                                        <RoomService
                                            fontSize="large"
                                            className={
                                                novoPedidoRecente
                                                    ? classes.bandejaBalancando
                                                    : undefined
                                            }
                                        />
                                    </IconButton>
                                </Tooltip>
                            )}

                            <BarraPerfil
                                alertasCount={alertasSistema.length}
                                onAbrirAlertas={() => setAbrirAlertas(true)}
                                onMeuPerfil={handleDadosFornecedor}
                                onCaixa={
                                    emModoGarcom
                                        ? undefined
                                        : () => history.push("/servicos/modulo/caixa")
                                }
                                onRegistrador={() => handleRegistradorDePedidos()}
                                onMesas={handlePedidoDeMesa}
                                onTrocarEstabelecimento={handleToggleDialogAlterarEstabelecimento}
                                onEditarAplicativo={
                                    perfilAdm
                                        ? () => history.push("/servicos/modulo/editar-aplicativo")
                                        : undefined
                                }
                                onSair={() => setDialogSair(true)}
                            />
                        </div>
                    </Toolbar>

                    {/* Stack de faixas de alerta abaixo do cabeçalho (topo da página),
                        em todas as telas. Fica DENTRO do AppBar, logo abaixo da Toolbar,
                        herdando largura/offset/posição fixa do cabeçalho; o padding do
                        body (ver efeito acima) empurra o conteúdo para não sobrepor. */}
                    <div ref={bannerStackRef}>
                        {somBloqueado && (
                            <FaixaAlerta
                                cor="#e53935"
                                icone={<VolumeUp fontSize="small" />}
                                onClick={autorizarSom}
                            >
                                Som de novos pedidos bloqueado pelo navegador — clique aqui
                                para ativar o som
                            </FaixaAlerta>
                        )}
                        {emAvaliacao && (
                            <FaixaAlerta
                                cor="#2196f3"
                                icone={<InfoOutlined fontSize="small" />}
                                onClick={abrirAvaliacao}
                            >
                                Assinatura em período de avaliação
                                <span className="no-mobile"> — clique para saber mais</span>
                            </FaixaAlerta>
                        )}
                        {mostrarAlertaImpressao && (
                            <FaixaAlerta
                                cor="#f5a623"
                                icone={<ReportProblemOutlined fontSize="small" />}
                                onClick={() => setDialogImpressao(true)}
                                aoFechar={dispensarAlertaImpressao}
                            >
                                Módulo de impressão não encontrado
                                <span className="no-mobile"> — clique para saber mais</span>
                            </FaixaAlerta>
                        )}
                        {mostrarAvisoImpressora && (
                            <FaixaAlerta
                                cor="#f5a623"
                                icone={<ReportProblemOutlined fontSize="small" />}
                                onClick={() => setDialogConfigImpressao(true)}
                                aoFechar={dispensarAvisoImpressora}
                            >
                                {mensagemNaoConfigurado}
                                <span className="no-mobile">{complementoNaoConfigurado}</span>
                            </FaixaAlerta>
                        )}
                        {faturaBloqueada && (
                            <FaixaAlerta
                                cor="#e53935"
                                icone={<ReportProblemOutlined fontSize="small" />}
                                onClick={abrirFaturas}
                            >
                                Impressão e edição de cardápio bloqueados por inadimplência
                                <span className="no-mobile"> — clique para ver as faturas</span>
                            </FaixaAlerta>
                        )}
                        {faturaAberta && (
                            <FaixaAlerta
                                cor="#12b976"
                                icone={<InfoOutlined fontSize="small" />}
                                onClick={abrirFaturas}
                                aoFechar={dispensarFatura}
                            >
                                Sua fatura já foi gerada
                                <span className="no-mobile"> — clique para pagar</span>
                            </FaixaAlerta>
                        )}
                    </div>
                </AppBar>

                <Dialog
                    open={dialogAvaliacao}
                    onClose={() => setDialogAvaliacao(false)}
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogTitle>Assinatura em período de avaliação</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Sua assinatura está em período de avaliação gratuito. Realize o
                            pagamento da fatura em aberto até o vencimento para não perder acesso ao
                            sistema.
                        </DialogContentText>
                        {faturaAvaliacao && (
                            <div
                                style={{
                                    marginTop: 12,
                                    padding: 16,
                                    borderRadius: 12,
                                    background: "#f5f7fa",
                                    border: "1px solid #e5e7eb",
                                }}
                            >
                                <div style={{ fontWeight: 700, marginBottom: 6 }}>
                                    Fatura em aberto
                                </div>
                                {faturaAvaliacao.valor != null && (
                                    <div>
                                        Valor:{" "}
                                        <strong>
                                            R${" "}
                                            {Number(faturaAvaliacao.valor)
                                                .toFixed(2)
                                                .replace(".", ",")}
                                        </strong>
                                    </div>
                                )}
                                {faturaAvaliacao.dataVencimento && (
                                    <div>
                                        Vencimento:{" "}
                                        {formatarVencimento(faturaAvaliacao.dataVencimento)}
                                    </div>
                                )}
                            </div>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setDialogAvaliacao(false)}>Fechar</Button>
                        {(faturaAvaliacao?.url || faturaAvaliacao?.urlIugu) && (
                            <Button
                                color="primary"
                                variant="contained"
                                href={faturaAvaliacao.url || faturaAvaliacao.urlIugu}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Pagar fatura
                            </Button>
                        )}
                    </DialogActions>
                </Dialog>

                <Drawer
                    variant="permanent"
                    className={clsx(classes.drawer, {
                        [classes.drawerOpen]: openBarraLateral,
                        [classes.drawerClose]: !openBarraLateral,
                    })}
                    classes={{
                        paper: clsx(classes.scrollbarCustom, {
                            [classes.drawerOpen]: openBarraLateral,
                            [classes.drawerClose]: !openBarraLateral,
                        }),
                    }}
                >
                    <div className={classes.drawerHeaderMini}>
                        <IconButton
                            onClick={openBarraLateral ? handleDrawerClose : handleDrawerOpen}
                        >
                            {openBarraLateral ? (
                                <ChevronLeft style={{ color: "white" }} />
                            ) : (
                                <Menu style={{ color: "white" }} />
                            )}
                        </IconButton>
                    </div>
                    <Divider style={{ padding: "0", backgroundColor: "white" }} />

                    {openBarraLateral ? (
                        menuContent()
                    ) : isPerfilWhatsappOperador ? (
                        <div>
                            <List>
                                {perfilCompleto && (
                                    <Tooltip title="Menu" placement="right">
                                        <ListItem
                                            button
                                            onClick={() => {
                                                handleHome()
                                            }}
                                            style={{
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                padding: "8px 4px",
                                                minHeight: "60px",
                                            }}
                                        >
                                            <Dashboard style={{ marginBottom: "2px" }} />
                                            <Typography
                                                variant="caption"
                                                style={{
                                                    fontSize: "9px",
                                                    color: "#bdc3c7",
                                                    textAlign: "center",
                                                    lineHeight: 1,
                                                }}
                                            >
                                                Menu
                                            </Typography>
                                        </ListItem>
                                    </Tooltip>
                                )}
                                <Tooltip title="Chat" placement="right">
                                    <ListItem
                                        button
                                        onClick={() => handleConversasWhatsapp()}
                                        style={{
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            padding: "8px 4px",
                                            minHeight: "60px",
                                        }}
                                    >
                                        <Chat style={{ marginBottom: "2px" }} />
                                        <Typography
                                            variant="caption"
                                            style={{
                                                fontSize: "9px",
                                                color: "#bdc3c7",
                                                textAlign: "center",
                                                lineHeight: 1,
                                            }}
                                        >
                                            Chat
                                        </Typography>
                                    </ListItem>
                                </Tooltip>
                                <Tooltip title="Cadastrar templates" placement="right">
                                    <ListItem
                                        button
                                        onClick={() => handleCriarTemplateWhatsapp()}
                                        style={{
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            padding: "8px 4px",
                                            minHeight: "60px",
                                        }}
                                    >
                                        <PostAdd style={{ marginBottom: "2px" }} />
                                        <Typography
                                            variant="caption"
                                            style={{
                                                fontSize: "9px",
                                                color: "#bdc3c7",
                                                textAlign: "center",
                                                lineHeight: 1,
                                            }}
                                        >
                                            Cadastrar
                                            <br />
                                            templates
                                        </Typography>
                                    </ListItem>
                                </Tooltip>
                                <Tooltip title="Disparar templates" placement="right">
                                    <ListItem
                                        button
                                        onClick={() => handleEnvioTemplateWhatsappGrupo()}
                                        style={{
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            padding: "8px 4px",
                                            minHeight: "60px",
                                        }}
                                    >
                                        <Send style={{ marginBottom: "2px" }} />
                                        <Typography
                                            variant="caption"
                                            style={{
                                                fontSize: "9px",
                                                color: "#bdc3c7",
                                                textAlign: "center",
                                                lineHeight: 1,
                                            }}
                                        >
                                            Disparar
                                            <br />
                                            templates
                                        </Typography>
                                    </ListItem>
                                </Tooltip>
                            </List>
                        </div>
                    ) : (
                        <div>
                            <List>
                                {/* <Tooltip title="Fatura Disponível" placement="right">
                                    <ListItem
                                        button
                                        onClick={handleFatura}
                                        style={{
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            padding: "8px 4px",
                                            backgroundColor: "#27ae60",
                                            margin: "4px 8px",
                                            borderRadius: "8px",
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontSize: "18px",
                                                marginBottom: "2px",
                                                color: "white",
                                            }}
                                        >
                                            $
                                        </span>
                                        <Typography
                                            variant="caption"
                                            style={{
                                                fontSize: "10px",
                                                color: "white",
                                                textAlign: "center",
                                                lineHeight: 1,
                                            }}
                                        >
                                            Fatura
                                            <br />
                                            Disponível
                                        </Typography>
                                    </ListItem>
                                </Tooltip> */}

                                {secoesVisiveis.map(secao => {
                                    const path = rotaDaSecao(secao)
                                    return (
                                        <Tooltip
                                            key={secao.key}
                                            title={secao.label}
                                            placement="right"
                                        >
                                            <ListItem
                                                button
                                                component={path ? "a" : "div"}
                                                href={path}
                                                onClick={e =>
                                                    clicarLink(e, path, () =>
                                                        acionarSecao(secao, e)
                                                    )
                                                }
                                                style={{
                                                    flexDirection: "column",
                                                    justifyContent: "center",
                                                    padding: "8px 4px",
                                                    minHeight: "60px",
                                                }}
                                            >
                                                <span
                                                    style={{ marginBottom: "2px", display: "flex" }}
                                                >
                                                    {secao.novo ? (
                                                        <Badge
                                                            color="error"
                                                            badgeContent="novo"
                                                            overlap="rectangular"
                                                            anchorOrigin={{
                                                                vertical: "top",
                                                                horizontal: "right",
                                                            }}
                                                            classes={{ badge: classes.badgeNovo }}
                                                        >
                                                            {secao.icon}
                                                        </Badge>
                                                    ) : (
                                                        secao.icon
                                                    )}
                                                </span>
                                                <Typography
                                                    variant="caption"
                                                    style={{
                                                        fontSize: "9px",
                                                        color: "#bdc3c7",
                                                        textAlign: "center",
                                                        lineHeight: 1,
                                                    }}
                                                >
                                                    {secao.labelMini || secao.label}
                                                </Typography>
                                            </ListItem>
                                        </Tooltip>
                                    )
                                })}
                            </List>
                        </div>
                    )}
                </Drawer>

                <Drawer
                    variant="temporary"
                    anchor="left"
                    open={mobileDrawerOpen}
                    onClose={handleMobileDrawerToggle}
                    className={classes.mobileDrawer}
                    classes={{
                        paper: clsx(classes.scrollbarCustom, classes.drawerOpen),
                    }}
                    ModalProps={{
                        keepMounted: true,
                    }}
                >
                    <div className={classes.drawerHeaderMini}>
                        <IconButton onClick={handleMobileDrawerToggle}>
                            <ChevronLeft style={{ color: "white" }} />
                        </IconButton>
                    </div>
                    <Divider style={{ padding: "0", backgroundColor: "white" }} />
                    {menuContent()}
                </Drawer>
            </div>

            <Popover
                open={Boolean(submenu.anchor)}
                anchorEl={submenu.anchor}
                onClose={fecharSubmenu}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
            >
                <List dense>
                    {submenu.secao?.items
                        ?.filter(it => it.gate !== false)
                        .map(it => {
                            if (it.subheader) {
                                return (
                                    <ListSubheader
                                        key={`sub-${it.subheader}`}
                                        disableSticky
                                        style={{
                                            fontWeight: "bold",
                                            lineHeight: "32px",
                                            color: "#000",
                                        }}
                                    >
                                        {it.subheader}
                                    </ListSubheader>
                                )
                            }
                            const path = rotaDoItem(it)
                            return (
                                <ListItem
                                    button
                                    key={it.label}
                                    component={path ? "a" : "li"}
                                    href={path}
                                    target={it.novaAba ? "_blank" : undefined}
                                    rel={it.novaAba ? "noopener noreferrer" : undefined}
                                    onClick={e => {
                                        // Item de nova aba: deixa o próprio <a target="_blank">
                                        // abrir, sem navegar a aba atual pela SPA.
                                        if (it.novaAba && path) {
                                            fecharSubmenu()
                                            return
                                        }
                                        clicarLink(e, path, () => {
                                            it.onClick?.()
                                            fecharSubmenu()
                                        })
                                    }}
                                >
                                    <ListItemText
                                        primary={
                                            <span
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 8,
                                                }}
                                            >
                                                {it.label}
                                                {it.exclusivo && (
                                                    <Chip
                                                        size="small"
                                                        label="Cliente Fiel"
                                                        title="Item exclusivo, visível apenas para usuários Cliente Fiel"
                                                        style={{
                                                            height: 18,
                                                            fontSize: 10,
                                                            fontWeight: "bold",
                                                            backgroundColor: "#7b1fa2",
                                                            color: "#fff",
                                                        }}
                                                    />
                                                )}
                                                {it.novo && (
                                                    <Chip
                                                        size="small"
                                                        label="novo"
                                                        style={{
                                                            height: 18,
                                                            fontSize: 10,
                                                            fontWeight: "bold",
                                                            textTransform: "uppercase",
                                                            backgroundColor: "#e53935",
                                                            color: "#fff",
                                                        }}
                                                    />
                                                )}
                                            </span>
                                        }
                                    />
                                </ListItem>
                            )
                        })}
                </List>
            </Popover>
        </>
    )
}
